import { render, staticRenderFns } from "./PricingListSubAndSkillDive.vue?vue&type=template&id=aa9fdbb8&scoped=true&"
import script from "./PricingListSubAndSkillDive.vue?vue&type=script&lang=js&"
export * from "./PricingListSubAndSkillDive.vue?vue&type=script&lang=js&"
import style0 from "./PricingListSubAndSkillDive.vue?vue&type=style&index=0&id=aa9fdbb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9fdbb8",
  null
  
)

export default component.exports